import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { applyDocumentLanguage, SUPPORTED_LNGS } from "./locales";

/** Per-build stamp injected by Vite (see vite.config.mts `define`). */
declare const __MESSAGES_VERSION__: string;

// Cache-bust message files per build in prod so new keys aren't masked by a
// stale cached JSON. Dev fetches plain so an edit + reload always loads fresh.
const loadPath = import.meta.env.PROD
  ? `/messages/{{lng}}.json?v=${__MESSAGES_VERSION__}`
  : "/messages/{{lng}}.json";

/**
 * i18n init (side-effect import in main.tsx). Messages load from
 * `public/messages/{lng}.json`. Keep keys namespaced per feature as the app
 * grows; never hardcode user-facing copy in components. The active language is
 * browser-detected (overridable via the Settings → General selector) and
 * reflected onto `<html lang>` / `<html dir>` for SEO, a11y, and RTL.
 */
i18n.use(HttpBackend).use(LanguageDetector).use(initReactI18next);

i18n.on("languageChanged", applyDocumentLanguage);

void i18n
  .init({
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LNGS,
    interpolation: { escapeValue: false },
    backend: { loadPath },
    detection: { caches: ["localStorage"] },
  })
  .then(() => {
    if (i18n.resolvedLanguage) applyDocumentLanguage(i18n.resolvedLanguage);
  });
